import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../../base.component';
import {MatDialogRef} from '@angular/material/dialog';
import {AddOrUpdateServicesOptions} from './options/add-or-update-services.options';
import {DataResponse} from '../../../../network/service/data.response';
import {SnackBarUtil} from '../../../../util/snack.bar.util';

@Component({
  selector: 'app-add-or-update-services',
  standalone: false,
  templateUrl: './add-or-update-services.component.html',
  styleUrl: './add-or-update-services.component.scss'
})
export class AddOrUpdateServicesComponent extends BaseComponent implements OnInit {
  addOrUpdateProductOptions = new AddOrUpdateServicesOptions();
  servicePrice?: any;
  productId?: string;
  imageFiles?: any;
  images?: string[];
  title?: any;
  price?: string;
  newPrice?: string;
  maxCapacity?: number;
  priority: number = 0;
  isActive?: boolean;
  description: string = '';
  startTime?: any;
  endTime?: any;
  categoryId?: string;
  branchId?: string;
  uniqueIdentifier?: string;
  isChangeCapacity?: boolean = true;

  constructor(injector: Injector, private readonly matDialogRef: MatDialogRef<AddOrUpdateServicesComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.branchId = this.addOrUpdateProductOptions.branchId;
    this.categoryId = this.addOrUpdateProductOptions.categoryId;
    this.servicePrice = this.addOrUpdateProductOptions.service.ServicePrices?.find((servicePrice: any) => servicePrice.BusinessId === this.branchId);
    this.title = this.addOrUpdateProductOptions.service.Title;
    this.priority = this.addOrUpdateProductOptions.service.Priority;
    this.description = this.addOrUpdateProductOptions.service.Description;
    this.isActive = this.addOrUpdateProductOptions.service.IsActive;
    this.images = this.addOrUpdateProductOptions.service.Images;
    this.uniqueIdentifier = this.addOrUpdateProductOptions.service.UniqueIdentifier;
    if (this.images) {
      this.imageFiles = this.images.map((image: string) => {
        return {
          name: image
        };
      });
    }
    if (this.servicePrice) {
      this.price = this.servicePrice.Price;
      this.newPrice = this.servicePrice.NewPrice;
      this.maxCapacity = this.getRemainedCount(this.servicePrice);
      this.startTime = this.servicePrice.StartTime;
      this.endTime = this.servicePrice.EndTime;
    }
  }

  override loadOnline() {
    super.loadOnline();
  }

  noAction() {
    this.matDialogRef.close();
  }

  getRemainedCount(servicePrice: any): number {
    return servicePrice.MaxCapacity - servicePrice.OrderedCount;
  }

  upload(index: number, onFinished: any) {
    if (!this.imageFiles || this.imageFiles.length === 0) {
      return onFinished();
    }
    if (index >= this.imageFiles!.length) {
      onFinished();
    } else {
      if (this.imageFiles[index] instanceof File) {
        let formData = new FormData();
        formData.append('File', this.imageFiles[index]);
        this.serviceApi.upload(formData).subscribe((res: DataResponse<any>) => {
          if (res.data) {
            this.images!.push(res.data.dataValues.FileId);
            this.upload(++index, onFinished);
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
      } else {
        this.images!.push(this.imageFiles[index].name);
        this.upload(++index, onFinished);
      }
    }
  }

  onSubmitClicked() {
    if (this.isRequiredFieldsFilled(this.price, this.maxCapacity)) {
      this.images = [];
      this.upload(0, () => {
        (this.addOrUpdateProductOptions.service.ServiceId !== undefined ? this.serviceApi.updateServices(this.addOrUpdateProductOptions.service.ServiceId, {
          Title: this.title,
          Images: this.images,
          Price: this.price,
          NewPrice: this.newPrice,
          MaxCapacity: this.maxCapacity,
          Priority: this.priority,
          IsChangeRemainedCapacity: this.isChangeCapacity,
          Description: this.description,
          StartTime: this.startTime,
          EndTime: this.endTime,
          CategoryId: this.categoryId,
          UniqueIdentifier: this.uniqueIdentifier,
          BusinessId: this.branchId
        }) : this.serviceApi.createServices({
          Title: this.title,
          Images: this.images,
          Price: this.price,
          NewPrice: this.newPrice,
          MaxCapacity: this.maxCapacity,
          Priority: this.priority,
          Description: this.description,
          StartTime: this.startTime,
          EndTime: this.endTime,
          CategoryId: this.categoryId,
          UniqueIdentifier: this.uniqueIdentifier,
          BusinessId: this.branchId
        })).subscribe((res: DataResponse<any>) => {
          if (res.success) {
            this.addOrUpdateProductOptions.onInsertOrUpdateFinished();
            this.noAction();
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
      });
    }
  }
}
